import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { DatePicker, DatePickerProps } from '@material-ui/pickers'
import { purple, gray, dangers } from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'

const useStyles = ({ variant, disabled, disableDatePickerValidationErrors }) =>
	makeStyles((theme) => ({
		calendarButton: {
			'& svg': {
				fill: theme.palette.primary.main
			}
		},
		calendarHeaderButtons: {
			fill: theme.palette.primary.main
		},
		calendarContainer: {
			flex: 1,
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			'& .MuiFormHelperText-root.Mui-error': {
				display: disabled || disableDatePickerValidationErrors ? 'none' : 'inherit'
			},
			'& .MuiFilledInput-underline.Mui-error:after': {
				borderBottomColor: disabled || disableDatePickerValidationErrors ? gray[500] : dangers[500],
				borderBottomWidth: disabled || disableDatePickerValidationErrors ? 1 : 2
			},
			'& .MuiPickersCalendarHeader-switchHeader': {
				margin: '1.2rem 0',
				'& .MuiTypography-body1': {
					fontSize: '1rem',
					fontFamily: 'Nunito',
					fontWeight: FONT_WEIGHTS.ExtraBold,
					color: gray[900]
				},
				'& .MuiButtonBase-root.MuiIconButton-root.MuiPickersCalendarHeader-iconButton': {
					border: `0 solid ${gray[500]}`,
					width: '1.3125rem',
					height: '1.3125rem',
					margin: '0 1rem',
					'& .MuiIconButton-label': {
						'& .MuiSvgIcon-root': {
							fontSize: '1.1rem',
							color: gray[700],
							fill: gray[700]
						}
					}
				}
			},
			'& .MuiPickersBasePicker-pickerView': {
				justifyContent: variant === 'static' ? 'flex-start' : 'center'
			},
			'& .MuiPickersBasePicker-pickerViewLandscape': {
				padding: 0
			},
			'& .MuiPickersCalendar-week': {
				marginBottom: '.2rem'
			},
			'& .MuiPickersDay-day': {
				'& .MuiIconButton-label > p': {
					fontFamily: 'Nunito',
					fontWeight: FONT_WEIGHTS.Bold,
					fontSize: '1rem'
				}
			},
			'& .MuiPickersDay-day:hover': {
				border: `0.09375rem solid ${purple[500]}`,
				backgroundColor: gray[100]
			},
			'& .MuiPickersDay-day.MuiPickersDay-dayDisabled': {
				color: gray[500],
				'& .MuiIconButton-label > p': {
					fontWeight: FONT_WEIGHTS.Normal,
					textDecoration: 'line-through'
				}
			},
			'& .MuiPickersDay-day.MuiPickersDay-daySelected': {
				backgroundColor: purple[500],
				borderColor: purple[500],
				borderWidth: '0.09375rem',
				'& .MuiIconButton-label > p': {
					color: gray[100]
				}
			},
			'& .MuiPickersDay-day.MuiPickersDay-daySelected:hover': {
				backgroundColor: purple[500],
				borderColor: purple[500],
				borderWidth: '0.09375rem',
				'& .MuiIconButton-label > p': {
					color: gray[100]
				}
			},
			'& .MuiPickersCalendarHeader-daysHeader': {
				'& .MuiPickersCalendarHeader-dayLabel': {
					color: gray[900],
					fontFamily: 'Nunito',
					fontSize: '0.875rem',
					fontWeight: FONT_WEIGHTS.Medium
				}
			}
		}
	}))

/**
 * A Styled DatePicker with optional header element
 * @param {DatePickerProps & {header?: string | undefined, disableDatePickerValidationErrors?: boolean}} props
 * @returns
 */

const StyledDatePicker = (props) => {
	const classes = useStyles({
		variant: props.variant,
		disabled: props.disabled,
		disableDatePickerValidationErrors: props.disableDatePickerValidationErrors || false
	})()

	const propsToPassToDatePicker = { ...props }
	if (propsToPassToDatePicker.header) {
		delete propsToPassToDatePicker.header
	}
	if (propsToPassToDatePicker.disableDatePickerValidationErrors) {
		delete propsToPassToDatePicker.disableDatePickerValidationErrors
	}

	return (
		<div className={classes.calendarContainer}>
			{props.header ? <Typography variant="overline">{props.header}</Typography> : null}
			<DatePicker
				{...propsToPassToDatePicker}
				PopoverProps={{
					className: classes.calendarContainer
				}}
			/>
		</div>
	)
}

export default StyledDatePicker
